module.exports = __webpack_public_path__ + "static/assets/c20f444ba23534c6be1f9910176785db.png";